import React from 'react';
import SchedulerCalendar from '../../../components/calendar/SchedulerCalendar';
const NORTE_ID = '3584e7ad-4e70-4c07-adde-862486572d07';

export default function ViewTerpelNorte() {
  return (
    <div className="operation-view terpel-norte-view">
      <SchedulerCalendar operationId={NORTE_ID} />
    </div>
  );
}